import { styled } from '@mui/material';

interface RootStyledProps {
  attrs: {
    hidden: boolean;
  };
}

export const RootStyled = styled('div')<RootStyledProps>(
  ({ theme, attrs }) => ({
    display: attrs.hidden ? 'none' : 'block',

    '&:not(:last-child)': {
      paddingBottom: theme.spacing(2),
      borderBottom: !attrs.hidden
        ? `1px solid ${theme.palette.dark.dark_5}`
        : 0,
    },
    '&:not(:first-child)': {
      paddingTop: theme.spacing(2),
    },
  }),
);
